﻿
export default class NavigationCard {

    cardSelector = '[data-js-nav-card]';
    firstClass = 'navigation-card__inner--first';
    lastClass = 'navigation-card__inner--last';
    responsiveClass = 'is-mobile';

    responsive = false;

    constructor() {
        //this.setUpCards();
        //this.setUpResponsive();
    }

    //setUpResponsive() {
    //    window.addEventListener('resize', () => {
    //        this.setUpCards();
    //    })
    //}

    //setUpCards() {
    //    const elements = getElementList(document, this.cardSelector);

    //    if (elements.length !== 0) {
    //        const first = elements[0];
    //        const last = elements[elements.length - 1];

    //        const width = window.innerWidth;

    //        if (width < 768) {
    //            this.responsive = true;
               
    //            if (!first.classList.contains(this.firstClass)) {
    //                first.classList.add(this.firstClass);
    //                last.classList.add(this.lastClass);
    //            }

    //        } else {
    //            this.responsive = false;
    //            first.classList.remove(this.firstClass);
    //            last.classList.remove(this.lastClass);
    //        }
    //    } else {
    //        return;
    //    }
    //}
}


function getElementList(parent, query) {
    const elements = parent.querySelectorAll(query);
    return Array.from(elements);
}

